import { ViewModeCapabilityCoordinator } from '@mobile-mapping/web3d';
import { CapabilityRegistry } from '@trimble/web3d';
import { StationsCapabilityProvider } from '@trimble/web3d-providers';

function isAnyPaneInViewMode(
  registry: CapabilityRegistry,
  type: string
): boolean {
  for (const container of registry.paneContainers()) {
    const coordinator = container.get(ViewModeCapabilityCoordinator)();
    if (coordinator?.viewMode().type === type) {
      return true;
    }
  }
  return false;
}

export function isAnyPaneInPanoramaMode(registry: CapabilityRegistry): boolean {
  return isAnyPaneInViewMode(registry, 'Panorama');
}

export function hasLoadedStations(registry: CapabilityRegistry): boolean {
  const stations = registry.get(StationsCapabilityProvider)();
  return (stations?.stationCount() ?? 0) > 0;
}

export function resolveStationOpacityDisable(stationsLoaded: boolean): {
  readonly isDisabled: boolean;
  readonly disabledTooltipKey: string;
} {
  return {
    isDisabled: !stationsLoaded,
    disabledTooltipKey: 'mobileMapping.transparency.stationsNotLoaded',
  };
}

export function isAnyCadEditingEligible(
  registry: CapabilityRegistry,
  isEditingEligible: boolean
): boolean {
  if (!isEditingEligible) {
    return false;
  }
  return isAnyPaneInViewMode(registry, '3D');
}
